import { useCallback, useEffect, useState } from 'react';
import { analyticsService } from '../services/analyticsService';

const RECORDS_DATASET = 'records';

export default function useAnalyticsFormFields(dataset, campaignIds = [], leadsFormIds = []) {
  const [formFields, setFormFields] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (dataset !== RECORDS_DATASET || !campaignIds.length) {
      setFormFields([]);
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    const res = await analyticsService.getFormFields(campaignIds, leadsFormIds);
    setFormFields(res.ok ? res.data?.fields || [] : []);
    setIsLoading(false);
  }, [dataset, campaignIds, leadsFormIds]);

  useEffect(() => {
    load();
  }, [load]);

  return { formFields, isLoading, reload: load };
}
